export const isTextMarkdown = (text) => {
	const markdownPatterns = [
		/^#{1,6}\s/m, // Headers
		/^\s*[-*+]\s/m, // Unordered lists
		/^\s*\d+\.\s/m, // Ordered lists
		/\[.*?\]\(.*?\)/, // Links
		/!\[.*?\]\(.*?\)/, // Images
		/\*\*.*?\*\*/, // Bold
		/\*.*?\*/, // Italic
		/`.+?`/, // Inline code
		/```[\s\S]*?```/, // Code blocks
		/^>\s/m, // Blockquotes
		/^\|.*\|.*\|/m // Tables
	];
	return markdownPatterns.some(pattern => pattern.test(text));
};